import { DataDRequest } from "../DRequest";
import { IBoletaConfiguracion, IBoletaConfiguracionExtra2, IBoletaPlantilla } from "../entidad/Boleta";
import { Global } from "../Global";
import { DataUtil } from "../util/Util";

export function _SvBoletaPlantillaObtenerLista(idEscuela: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "boletaPlantilla/ObtenerLista"
    const params = {
        "IdEscuela": idEscuela,
        "Modificacion": null
    }
    return DataDRequest._Request5<IBoletaPlantilla[]>(url, "GET", params)
}

export function _SvBoletaPlantillaAgregar(idEscuela: number, idPlantilla: number, nombre: string, idsNivel: number[] | null, idsGrado: number[] | null, extras: IBoletaConfiguracionExtra2) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "boletaPlantilla/Agregar"
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdEscuela": idEscuela,
        "IdPlantilla": idPlantilla,
        "IdsNivel": (idsNivel?.length ? idsNivel : null),
        "IdsGrado": (idsGrado?.length ? idsGrado : null),
        "Nombre": nombre,
        "Extras": (extras ? JSON.stringify(extras) || null : null),
    }
    return DataDRequest._Request5(url, "POST", params)
}

export function _SvBoletaPlantillaActualizar(id: number, idPlantilla: number, nombre: string, idsNivel: number[] | null, idsGrado: number[] | null, extras: IBoletaConfiguracionExtra2) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "boletaPlantilla/Actualizar"
    const params = {
        "Id": id,
        "IdPlantilla": idPlantilla,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdsNivel": (idsNivel?.length ? idsNivel : null),
        "IdsGrado": (idsGrado?.length ? idsGrado : null),
        "Nombre": nombre,
        "Extras": (extras ? JSON.stringify(extras) || null : null),
    }
    return DataDRequest._Request5(url, "POST", params)
}

export function _SvBoletaPlantillaEliminar(id: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "boletaPlantilla/Eliminar"
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Id": id,
    }
    return DataDRequest._Request5(url, "POST", params)
}


export function _SvBoletaPlantillaObtenerConfiguracion(idEscuela: number, idNivel: number, idGrado: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "boletaPlantilla/ObtenerConfiguracion"
    const params = {
        "IdEscuela": idEscuela,
        "IdNivel": idNivel,
        "IdGrado": idGrado,
    }
    return DataDRequest._Request5<IBoletaConfiguracion>(url, "GET", params)
}
